export default "__VITE_ASSET___wD9L09V__"